package kz.dentalcrm.app.data.network.response_model.employees

import kotlinx.serialization.Serializable

@Serializable
data class ServiceServiceIdPivot(
    val employee_id: Int? = null,
    val service_id: Int? = null
)